export const VERIFY_FIRST_TIME_LOGIN = 'firstTimeLogin'
export const VERIFY_FORGOT_PASSWORD = 'forgotPassword'
export const TOKEN_FROM_EMAIL = 'TOKEN'
